export const MODEL_CATEGORY_NAME = 'Model';
export const CHARGING_CATEGORY_NAME = 'Charging';
export const variant1 = 'variant1';
export const variant2 = 'variant2';
